export default __webpack_public_path__ + "static/media/41c8162d-c2a6-49b0-8139-8bebab187588.1e47fb8b.woff2";